module.exports = __webpack_public_path__ + "img/download-on-the-appstore.56548226.png";